import { get, writable } from 'svelte/store';

const STORAGE_KEY = 'shelly-dev-widget-type-outlines';

const readInitialValue = (): boolean => {
	try {
		return localStorage.getItem(STORAGE_KEY) === '1';
	} catch {
		return false;
	}
};

/** Dev-only colored outlines for newest dashboard widget types. */
export const widgetTypeOutlinesEnabled = writable<boolean>(readInitialValue());

widgetTypeOutlinesEnabled.subscribe((value) => {
	try {
		localStorage.setItem(STORAGE_KEY, value ? '1' : '0');
	} catch {
		// localStorage may be unavailable
	}
});

export const isWidgetTypeOutlinesEnabled = (): boolean => get(widgetTypeOutlinesEnabled);

export const setWidgetTypeOutlinesEnabled = (enabled: boolean) => {
	widgetTypeOutlinesEnabled.set(enabled);
};
